export const getErrorPopupObject = (text, buttons) => {
  return {
    visible: true,
    title: "Error",
    text,
    buttons: buttons || [{
      text: "Close",
    }],
  }
}
